export default __webpack_public_path__ + "static/media/home-icon-2.74fd5f2f.png";